import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from './types';
import { getClient } from '../../common/utils';
import config from '../../config/app_config';

export function* getFontsWatcherSaga() {
  yield takeLatest(types.GET_FONTS_REQUEST, workerSaga);
}

export function fetchData() {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/utils/${client}/fontfamilies/`;

  return axios.get(url)
    .then(val => val)
    .catch(err => err);
}

export function* workerSaga(action) {
  try {
    const response = yield call(fetchData);

    if (response && response.status === 200) {
      const { data } = response;

      yield put({ type: types.GET_FONTS_SUCCESS, data });

    } else {
      yield put({ type: types.GET_FONTS_FAILURE, error: 'Failed to fetch fonts.'});
    }
  } catch (error) {
    console.log(error)
    yield put({ type: types.GET_FONTS_FAILURE, error });
  }
}
